export default __webpack_public_path__ + "static/individual.eglo-b2b-c9bc8dd8225b00dbeab8ee79c6d120f1.png";